import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../_helpers/auth.guard';

import { ChemistshopLayoutComponent } from './chemistshop-layout/chemistshop-layout.component';
import { ChemistshopDashboardComponent } from './chemistshop-dashboard/chemistshop-dashboard.component';
import { EbayOrdersComponent } from './ebay-orders/ebay-orders.component';
import { EbayOrderDetailsComponent } from './ebay-order-details/ebay-order-details.component';
import { GrouponOrdersComponent } from './groupon-orders/groupon-orders.component';
import { GrouponOrderDetailsComponent } from './groupon-order-details/groupon-order-details.component';
import { OnbuyOrdersComponent } from './onbuy-orders/onbuy-orders.component';
import { OnbuyOrderDetailsComponent } from './onbuy-order-details/onbuy-order-details.component';
import { ShipstationOrdersComponent } from './shipstation-orders/shipstation-orders.component';
import { ShipstationOrdersDetailsComponent } from './shipstation-orders-details/shipstation-orders-details.component';


const routes: Routes = [
  { 
    path: 'chemistshop', component: ChemistshopLayoutComponent, 
    children: [
      { path: '', component: ChemistshopDashboardComponent },
      { 
        path: 'dashboard', 
        component: ChemistshopDashboardComponent,
        data: { page: 'chemistshop_orders' }
      },
      {
        path: 'ebay', 
        children: [
          {
            path: 'ebay-orders',
            component: EbayOrdersComponent,
            data: { page: 'ebay_orders' }
          },
          { 
            path: 'ebay-order-details/:id', 
            component: EbayOrderDetailsComponent,
            data: { page: 'ebay_order_details' }
          },
        ]
      },
      {
        path: 'groupon', 
        children: [
          {
            path: 'groupon-orders',
            component: GrouponOrdersComponent,
            data: { page: 'groupon_orders' }
          },
          { 
            path: 'groupon-order-details/:id', 
            component: GrouponOrderDetailsComponent,
            data: { page: 'groupon-order-details' }
          },
        ]
      },
      {
        path: 'onbuy', 
        children: [
          {
            path: 'onbuy-orders',
            component: OnbuyOrdersComponent,
            data: { page: 'onbuy_orders' }
          },
          { 
            path: 'onbuy-order-details/:id', 
            component: OnbuyOrderDetailsComponent,
            data: { page: 'onbuy-order-details' }
          },
        ]
      },
      {
        path: 'shipstation', 
        children: [
          {
            path: 'shipstation-orders',
            component: ShipstationOrdersComponent,
            data: { page: 'shipstation_orders' }
          },
          { 
            path: 'shipstation-order-details/:id', 
            component: ShipstationOrdersDetailsComponent,
            data: { page: 'shipstation-order-details' }
          },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChemistshopeRoutingModule { }
